import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PageHeader, Loading, toastSuccessMessage } from "wup-module1-base";
import { PageTitleConstants, RoutePathConstants } from "../../../Constants";
// import { QuestionService } from "../../../Services";
import { Card } from "react-bootstrap";
import QuestionForm from "./Form/QuestionForm";

function QuestionEdit() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [model, setModel] = useState({});
  const navigate = useNavigate();

  const onSubmit = (question) => {
    setIsSubmitting(true);
    // QuestionService.update(id, question)
    //   .then((res) => {
    //     toastSuccessMessage(res.data);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsSubmitting(false);
    //   });
    const questions = JSON.parse(sessionStorage.getItem("questions"));
    const updatedQuestions = questions.map((item) =>
      item.id === id ? question : item
    );
    sessionStorage.setItem("questions", JSON.stringify(updatedQuestions));
    setIsSubmitting(false);
    toastSuccessMessage(`Pomyślnie edytowano pytanie ${question.name}`);
    navigate(`/${RoutePathConstants.Question}`);
  };

  useEffect(() => {
    setIsLoading(true);
    // DO IMPLEMENTACJI
    // QuestionService.getById(id)
    //   .then((res) => {
    //     const question = {
    //       ...res.data,
    //       relatedQuestions: res.data.relatedQuestions.sort((a, b) => a.order - b.order),
    //     };
    //     setModel(report);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    //   });

    const questions = JSON.parse(sessionStorage.getItem("questions"));
    if (!!questions) {
      const question = questions.find((i) => i.id === id);
      setModel(question);
      setIsLoading(false);
    }
  }, [id]);

  return (
    <>
      <PageHeader content={PageTitleConstants.QuestionEdit} />
      <Card>
        <Card.Body>
          {isLoading ? (
            <Loading />
          ) : (
            model && (
              <QuestionForm
                onSubmit={onSubmit}
                model={model}
                isEdit={true}
                isSubmitting={isSubmitting}
              />
            )
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default QuestionEdit;
